<template>
	<div
		:class="[
			'container__menuoptions__background',
			{ 'container__menuoptions__background--active': isBackdropActived },
		]"
		@click="clickOptionalEvent"
	/>
</template>

<script>
export default {
	props: {
		clickOptionalEvent: Function,
		isBackdropActived: {
			default: false,
			type: Boolean,
		},
	},
}
</script>

<style scoped>
.container__menuoptions__background {
	position: fixed;
	left: 0;
	top: var(--menu-height);
	height: 100vh;
	width: 0;
	background-color: rgba(0, 0, 0, 0);
	transition: background-color 0.5s ease-in-out;
}

.container__menuoptions__background--active {
	width: 100vw;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 5;
}

@media screen and (min-width: 992px) {
	.container__menuoptions__background {
		top: 0;
	}
}
</style>
